"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Card = _interopRequireDefault(require("./Card.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _String = _interopRequireDefault(require("./String.js"));

var _ButtonGridModule = _interopRequireDefault(require("./ButtonGrid.module.scss"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _core = require("@material-ui/core");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A toggle button grid
 */
class ButtonGrid extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `${_ButtonGridModule.default.grid} ${this.props.classes.grid} ${this.props.className || ""}`.trim(),
      style: this.styles,
      children: this.props.items.map((item, key) => {
        const isSelected = item.id === this.props.value;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.default, {
          className: `${_ButtonGridModule.default.button} ${isSelected ? this.props.classes.buttonSelected : ""} ${item.disabled ? this.props.classes.buttonDisabled : ""} ${this.props.classNameButton || ""} ${item.className || ""}`.trim(),
          disabled: item.disabled,
          name: this.props.name,
          onClick: this.props.onChange,
          outlined: true,
          square: true,
          value: item.value,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
            bold: isSelected,
            centre: true,
            noFlex: true,
            str: item.label
          })
        }, key);
      })
    });
  }
  /**
   * Styles.
   * 
   * @return {Object}
   */


  get styles() {
    return {
      gridTemplateColumns: `repeat(auto-fit, ${this.props.size})`
    };
  }
  /**
   * Styles.
   *
   * @param {Object} theme Material UI theme object
   * @return {Object}
   */


  static styles(theme) {
    return {
      grid: {
        "--button-border-color": theme.palette.type !== "dark" ? "#e0e0e0" : "#3a3a3a"
      },
      buttonDisabled: {
        cursor: "not-allowed",
        color: `${(0, _colorManipulator.fade)(theme.palette.text.primary, 0.5)} !important`
      },
      buttonSelected: {
        backgroundColor: props => `${(0, _colorManipulator.fade)(theme.palette[props.color].main, 0.1)} !important`,
        color: props => theme.palette[props.color].main
      }
    };
  }

  static propTypes = {
    className: _propTypes.default.string,
    classNameButton: _propTypes.default.string,
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    items: _propTypes.default.array,
    name: _propTypes.default.string,
    size: _propTypes.default.string,
    onChange: _propTypes.default.func
  };
  static defaultProps = {
    color: "primary",
    size: "12rem"
  };
}

var _default = (0, _core.withStyles)(ButtonGrid.styles)(ButtonGrid);

exports.default = _default;